import FormattedMessage from 'I18n/components/FormattedMessage';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { useSetQueryParams } from '../../app/hooks/useSetQueryParams';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function AllCaughtUpMessage({
  hasFirstPage = false,
  isRecommendedTab
}) {
  const setQueryParams = useSetQueryParams();

  // redirect to first page if the first page exists
  useEffect(() => {
    if (hasFirstPage) {
      setQueryParams({
        offset: ''
      });
    }
  }, [hasFirstPage, setQueryParams]);
  return /*#__PURE__*/_jsx(ResultsMessage, {
    illustration: "all-conversations-complete",
    children: isRecommendedTab ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.noRecommendedUpdates"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.allCaughtUp.description"
    })
  });
}
export default AllCaughtUpMessage;